export default "__VITE_ASSET__C1wc5kx7__"